/*
  TODO Dedupe from Demo/SliderControl?
*/
import React from 'react';
import { styled } from '@linaria/react';
import useBoundingBox from '@/hooks/use-bounding-box';

import ControlWrapper from '../ControlWrapper';
import DottedControlBackground from '../DottedControlBackground';
import Bezier from './Bezier';

function BezierControl({
  id,
  value,
  setValue,
  animateChanges,
  ...delegated
}) {
  const wrapperRef = React.useRef();

  const box = useBoundingBox(wrapperRef);

  const firstHandleId = `${id}-first-handle`;

  const borderWidth = 3;

  return (
    <ControlWrapper id={firstHandleId} {...delegated}>
      <InnerWrapper>
        <DottedControlBackground borderWidth={borderWidth} />
        <BezierWrapper
          ref={wrapperRef}
          style={{ '--inset-by': borderWidth + 5 + 'px' }}
        >
          {box && (
            <Bezier
              id={id}
              box={box}
              value={value}
              animateChanges={animateChanges}
              onChange={(v) => setValue(v)}
            />
          )}
        </BezierWrapper>
      </InnerWrapper>
    </ControlWrapper>
  );
}

const InnerWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
`;

const BezierWrapper = styled.div`
  position: absolute;
  top: calc(var(--inset-by));
  left: calc(var(--inset-by));
  right: calc(var(--inset-by));
  bottom: calc(var(--inset-by));
  touch-action: none;
`;

export default React.memo(BezierControl);
